<template>
  <div class="content">
    <div 
      v-if="Array.isArray(allwork_home) && allwork_home.length"
      class="dashboard">
      <!--  box allwork listing -->
      <div 
          class="dashboard-item" 
          v-for="(work,i) in allwork_home" 
          :key="i">
        <div class="image-circles">
          <progressive-img 
            class="image" 
            :src="file(work.ImageLink)" 
            :alt="work.Key">
            <div 
              slot-scope="{visible}" 
              v-if="visible" 
              class="loading-spinner-flex" 
              style="width:100%;height:100%">
              <i class="diginity dg-loading diginity-is-spinning"></i>
            </div>
          </progressive-img>
        </div>
        <div class="title">
          <router-link :to="work.TitleLink">
            <span>{{work.Key}}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['t', 'file', 'allwork_home'])
  },
  watch: {
    lng(newValue, oldValue) {
      this.$store.dispatch('allworks_home');
    }
  },
  async created() {
    await this.$store.dispatch('allworks_home');
  }
};
</script>


<style lang="scss" scoped>
.content {
  padding-bottom: 0 !important;
}
.dashboard {
  padding: 25px 0 0px;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  .dashboard-item {
    width: 50%;
    padding-top: 30px;
    padding-bottom: 30px;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    @media screen and (max-width: 480px) {
      width: 100%;
    }
    &:nth-child(odd) {
      background: #d1d2d4;
    }
    .image {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    }
    .title {
      padding: 10px;
      span {
        display: inline-block;
        padding: 5px 20px;
        border-top: 2px solid #949195;
        border-bottom: 2px solid #949195;
        color: #008cba;
      }
    }
  }
}
</style>
